<template>
  <b-row class="ie-11-radio-string-row">
    <b-col class="flex">
      <div
        class="check-item hovered"
        :class="{ checked: answer.text === value }"
        v-for="(answer, index) in question.answers"
        :key="index"
        @click="select(answer)"
      >
        <div
          class="item"
          :class="{ selected: answer.text === value }"
          :title="question.answers[index].text"
          role="button"
          :tabindex="index + 4"
          :aria-pressed="answer.text === value ? 'true' : 'false'"
          @keydown.enter.space="select(answer)"
          :id="'option' + (index + 1)"
        >
          <div class="check">
            {{ getFaceOfAnswer(answer) }}
          </div>
        </div>
        <label class="text" aria-hidden="true" :for="'option' + (index + 1)">{{
          question.answers[index].text
        }}</label>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ['question'],
  computed: {
    value: function() {
      return 'text' in (this.question.answered || {})
        ? this.question.answered.text
        : this.question.answered
    },
  },
  methods: {
    select(answer) {
      this.$emit('answer', answer)
    },
    getFaceOfAnswer({ score }) {
      switch (score) {
        case -2:
          return '😠'
        case -1:
          return '🙁'
        case 0:
          return '😐'
        case 1:
          return '🙂'
        case 2:
          return '😄'

        default:
          return ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

_:-ms-fullscreen,
:root .ie-11-radio-string-row {
  width: 100%;
}

.flex {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  justify-content: center;

  @media (max-width: 767px) {
    flex-direction: column-reverse;
    align-items: center;
  }

  @media (max-width: 425px) {
    min-height: 350px;
  }

  .check-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;

    @media (max-width: 767px) {
      flex-direction: row;
      margin-bottom: 10px;
    }

    .text {
      display: inline-block;
      color: map-get($theme-colors, 'gray04');
      font-size: 13px;
      font-weight: 500;
      width: 100px;
      cursor: pointer;
      margin-top: 20px;

      @media (max-width: 425px) {
        margin: 0;
      }
    }

    .circle {
      border-radius: 50%;
      transition: all ease-in-out 0.1s;
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: map-get($theme-colors, 'lima');
    }

    .item {
      border: 1.3rem solid map-get($theme-colors, 'gray-light');
      height: 90px;
      width: 90px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all ease 0.2s;
      cursor: pointer;

      &.selected {
        border: 1.3rem solid map-get($theme-colors, 'lima');
      }

      @media (max-width: 767px) {
        border: 0.95rem solid #f0f0f0;
        height: 60px;
        width: 60px;
      }

      .check {
        border-radius: 50%;
        transition: all ease-in-out 0.1s;
        width: 0px;
        height: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 60px;
        color: map-get($theme-colors, 'lima');

        @media (max-width: 767px) {
          font-size: 40px;
        }
      }
    }

    &:hover {
      .text {
        color: map-get($theme-colors, 'primary');
        font-weight: bold;
      }
    }

    &.checked {
      .item .check {
        width: 100%;
        height: 100%;
        border: solid 1px rgba(0, 168, 119, 0.5);
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      }

      .text {
        color: map-get($theme-colors, 'primary');
        font-weight: bold;
      }
    }
  }
}
</style>
